export const lyceumOrigin = window.LYCEUM_ORIGIN;
